import { ICellRendererParams } from '@trackman/baseball-shared-components';
import { IReviewDataRow } from 'interfaces/review/IReviewDataRow';
import React from 'react';
import { BaseRunnerWrapper, Divider, FinalState, InitialState } from './styles/baseRunnerRendererStyles';

const getNameRef = (val: unknown): string => {
  if (val && typeof val === 'object' && 'nameRef' in (val as Record<string, unknown>)) {
    const name = (val as { nameRef?: string }).nameRef;
    return name ?? 'Undefined';
  }
  return 'Undefined';
};

const baseRunnerRenderer = (data: ICellRendererParams<any, IReviewDataRow>) => {
  return (
    <BaseRunnerWrapper>
      <InitialState>{getNameRef(data.previousRow ? data.previousRow[data.columnKey as keyof IReviewDataRow] : undefined)}</InitialState>

      <Divider />
      <FinalState>{getNameRef(data.value)}</FinalState>
    </BaseRunnerWrapper>
  );
};

export default baseRunnerRenderer;
